import { createContext } from "react";

import type { ButtonVariant } from "./types";

export const ButtonContext = createContext<ButtonVariant>("outline");
